<template>
  <div :class="`app-wrapper lo_tlr ${theme}`" style="width:100vw;height:100vh;overflow: hidden;">
    <transition v-if="menu_bar.size!=''">
      <LeftMenu :style="`width:${menu_bar.size=='full'?'240px':'70px'}`" :class="`${menu_bar.size=='full'?'base_menu_bar':'base_menu_bar_mini'}`" :menu_bar="menu_bar"></LeftMenu>
    </transition>
    <div :class="`base_right ${menu_bar.size=='full'?'':'base_right_full'}`">
      <Navbar :menu_bar="menu_bar"/>
      <div style="width:100%;height:calc(100% - 65px);background:var(--bs-main-background);"><router-view></router-view></div>
    </div>
  </div>
</template>

<script>
import Navbar from '@/views/layout_tlr/Navbar.vue'
import LeftMenu from '@/views/layout_tlr/LeftMenu.vue'
import {fun_load_theme, fun_save_dict} from "@/utils/common";
import {querySysDictInfo} from "@/api/sys";

export default {
  name: 'Index',
  components: {Navbar,LeftMenu},
  data() {
    return {
      theme:'theme_default',
      current_user:{},
      menu_bar_size:'full',
      menu_bar:{size:''},
    };
  },
  methods: {
    fun_load_css(_theme) {
      fun_load_theme('tlr_'+_theme);
    },
  },
  mounted() {
    querySysDictInfo({pageSize:999999}).then(res => {fun_save_dict(res.rows)})
    const _theme = localStorage.getItem("theme_name");
    if(_theme) this.fun_load_css(_theme);
    this.menu_bar.size = localStorage.getItem('left_menu_bar')+''=='null'?'full':localStorage.getItem('left_menu_bar');
  }
};
</script>

<style>
  .base_menu_bar{width:240px;float:left;height:100%;transition: width .3s ease;}
  .base_menu_bar_mini{width:70px;float:left;height:100%;transition: width .3s ease;}
  .base_right{width:calc(100% - 240px);float:right;height:100%;overflow:hidden;transition: width .3s ease;}
  .base_right_full{width:calc(100% - 70px);transition: width .3s ease;}
</style>
